import MarketTrends from 'app/shared/models/MarketTrends';
import api from 'app/shared/utils/api';
import { getFAQParamsQuery, getMarketTrendsQuery, getTopMarketsQuery } from 'app/shared/utils/queries';
import constants from 'app/shared/flux/constants';
import TopMarkets from 'app/shared/models/TopMarkets';
import { isEmpty } from 'app/shared/utils/marketTrendsUtils';

const NON_CRITICAL_ERRORS = ['INVALID_INPUT'];

export const getMarketTrends = (params: {
  resourceId: string;
  bedrooms?: string;
  propertyTypes?: string;
  otherResourceId?: string;
}) => {
  const { resourceId, bedrooms, propertyTypes, otherResourceId } = params;
  // @ts-ignore
  return async (dispatch) => {
    let res = {};
    const { data, errors } = await dispatch(
      api.area.graphQlMarketTrends(getMarketTrendsQuery({ resourceId, bedrooms, propertyTypes, otherResourceId })),
    ); // when resourceId is invalid (e.g. not-a-real-id) this throws an error, so marketTrends stays empty

    const marketTrends = new MarketTrends(data.marketPage, resourceId, otherResourceId);
    const hasFilters = bedrooms || propertyTypes;
    if (!hasFilters) {
      dispatch({
        type: constants.SET_UNFILTERED_MARKET_STATS,
        payload: marketTrends,
      });
    }
    if (isEmpty(marketTrends)) {
      await dispatch(getTopMarkets(params));
      res = { changeHttpStatus: 404 };
    }
    dispatch({
      type: constants.SET_MARKET_STATS,
      payload: marketTrends,
    });
    if (errors.length > 0) {
      errors.forEach((error: Error) => {
        // @ts-ignore
        if (!error.code in NON_CRITICAL_ERRORS) {
          // @ts-ignore
          throw new Error(error.code);
        }
      });
    }
    return res;
  };
};

export const getUnfilteredMarketTrends = (resourceId: string) => {
  // @ts-ignore
  return async (dispatch) => {
    const { data, errors } = await dispatch(api.area.graphQlMarketTrends(getFAQParamsQuery(resourceId)));
    dispatch({
      type: constants.SET_UNFILTERED_MARKET_STATS,
      payload: new MarketTrends(data.marketPage, resourceId),
    });
    if (errors.length > 0) {
      errors.forEach((error: Error) => {
        // @ts-ignore
        if (!error.code in NON_CRITICAL_ERRORS) {
          // @ts-ignore
          throw new Error(error.code);
        }
      });
    }
    return {};
  };
};

export const getTopMarkets = (params: { bedrooms?: string; propertyTypes?: string }) => {
  // @ts-ignore
  return async (dispatch) => {
    const { data, errors } = await dispatch(api.area.graphQlMarketTrends(getTopMarketsQuery(params)));
    if (errors.length > 0) {
      throw new Error(errors[0].code);
    }
    dispatch({
      type: constants.SET_TOP_MARKETS,
      payload: new TopMarkets(data),
    });
    return {};
  };
};
